import { render } from "./ImageUploadModal.vue?vue&type=template&id=2150d256&scoped=true"
import script from "./ImageUploadModal.vue?vue&type=script&lang=js"
export * from "./ImageUploadModal.vue?vue&type=script&lang=js"

import "./ImageUploadModal.vue?vue&type=style&index=0&id=2150d256&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2150d256"]])

export default __exports__